// Web Vitals monitoring for Core Web Vitals tracking
import { trackEvent } from './analytics';

export interface WebVitalMetric {
  name: string;
  value: number;
  rating: 'good' | 'needs-improvement' | 'poor';
}

// Thresholds based on Google's Core Web Vitals
const THRESHOLDS = {
  LCP: { good: 2500, poor: 4000 },
  FID: { good: 100, poor: 300 },
  CLS: { good: 0.1, poor: 0.25 },
  FCP: { good: 1800, poor: 3000 },
  TTFB: { good: 800, poor: 1800 },
  INP: { good: 200, poor: 500 },
};

function getRating(name: string, value: number): 'good' | 'needs-improvement' | 'poor' {
  const threshold = THRESHOLDS[name as keyof typeof THRESHOLDS];
  if (!threshold) return 'good';
  
  if (value <= threshold.good) return 'good';
  if (value <= threshold.poor) return 'needs-improvement';
  return 'poor';
}

export function initWebVitals() {
  if (typeof window === 'undefined') return;

  // Dynamic import to avoid build issues
  import('web-vitals').then(({ onCLS, onLCP, onFCP, onTTFB, onINP }) => {
    const reportMetric = (metric: { name: string; value: number }) => {
      const rating = getRating(metric.name, metric.value);
      
      trackEvent({
        action: 'web_vital',
        category: 'Performance',
        label: `${metric.name}_${rating}`,
        value: Math.round(metric.value),
      });

      console.log(`📊 Web Vital: ${metric.name} = ${Math.round(metric.value)}ms (${rating})`);
    };

    onCLS(reportMetric);
    onLCP(reportMetric);
    onFCP(reportMetric);
    onTTFB(reportMetric);
    onINP(reportMetric);
  });
}
